import { formatPercent, formatPlain } from "./number";

export const numberTick = (value: unknown) => typeof value === "number" ? formatPlain(value) : String(value ?? "");

export const percentTick = (fraction: number) => formatPercent(fraction * 100, 0);
